export default __webpack_public_path__ + "static/media/2323.8821126b.png";